import React, {useEffect, useState} from "react";
import {Route, Redirect, Link} from "react-router-dom";
import {Menu, Header} from "extranet-component-library";
import {observer} from "mobx-react";
import {MENU} from "../utils/constants";
import {useStores} from "../hooks/useStores";
import {useTranslation} from "react-i18next";
import mail from "../assets/img/MAIL.svg";
import avatar from "../assets/img/red-user.svg";
import alert from "../assets/img/ALARM.svg";
import log_out from "../assets/img/LOGOUT_RED.svg";
import close from "../assets/img/CLOSE.svg";
import MobileMenu from "../components/MobileMenu";
import home from "../assets/img/Home.svg";
import burger from "../assets/img/Burger.svg";
import CardsMenu from "../components/CardsMenu";
import {getBreadcrumbs} from "../utils/parsers";
import FooterComp from "../components/FooterComp";
import { useKeycloak } from "@react-keycloak/web";
import { isContactMenuVisible, getNotificationsLabel } from "../utils/entities/entityMenuVisibility";
import { getEntityImageConfig } from "../utils/entities/entityImageConfig";

const {REACT_APP_BASE_URL, REACT_APP_LOGIN_URL} = process.env;

export const PrivateRoute = observer(
    ({component: Component, isAuthenticated, ...rest}: any) => {
        const { keycloak: { idToken } } = useKeycloak();
        const {myTibStore, translationStore} = useStores();
        const {t} = useTranslation();
        const {profile, settings} = myTibStore;
        const [collapsed, setCollapsed] = useState(false);
        const showBreadcrumbsInViews: Array<string> = [];


        useEffect(
            () => {
                myTibStore.getSettings();
            },
            // eslint-disable-next-line react-hooks/exhaustive-deps
            [],
        );

        useEffect(() => {
            if (settings && settings.language) {
                translationStore.setLanguage(settings.language);
            }

            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [settings && settings.language]);

        const logout = () => {
            window.location.replace(
                `${REACT_APP_LOGIN_URL}/realms/ctm/protocol/openid-connect/logout?id_token_hint=${idToken}&post_logout_redirect_uri=${REACT_APP_BASE_URL}`
            );
        };

        const navigate = (props: any, url: string) => {
            document.body.classList.remove('no-scroll');
            if (!url.startsWith("https://")) {
                props.history.push(url);
            }
            setCollapsed(false);
        };

        const linkNavigate = (url: string, children: Array<any>,) => <Link to={url}>{children}</Link>;

        const handleCollapse = (state: boolean) => {
            setCollapsed(state);
            if (!collapsed) {
                document.body.classList.add('no-scroll');
            } else {
                document.body.classList.remove('no-scroll');
            }
        }

        const showContactMenu = isContactMenuVisible();
        const { headerLogo, headerTibLogo } = getEntityImageConfig();

        return (
            <Route
                {...rest}
                render={(props) =>
                    isAuthenticated ? (
                        <>
                            <Header
                                logoUrl={REACT_APP_BASE_URL ? REACT_APP_BASE_URL : ""}
                                profileUrl={MENU.PROFILE.URL}
                                logo={headerLogo}
                                tib={headerTibLogo}
                                user={
                                    profile
                                        ? {
                                            ...profile,
                                            avatar:avatar,
                                        }
                                        : {
                                            avatar: avatar,
                                        }
                                }
                                outLogo={log_out}
                                homeLogo={home}
                                burgerLogo={burger}
                                breadcrumbs={getBreadcrumbs(props.location.pathname)}
                                LinkNavigate={(props: any) => linkNavigate(props.to, props.children)}
                                onBurgerClick={() => handleCollapse(!collapsed)}
                                collapsed={collapsed}
                                closeLogo={close}
                                onLogout={() => logout()}
                                showBreadcrumbs={showBreadcrumbsInViews}
                            />
                            <MobileMenu
                                props={props}
                                navigate={navigate}
                                collapsed={collapsed}
                                onLogout={() => logout()}
                            />
                            <div className="pre-page" style={props && props.location && showBreadcrumbsInViews.includes(props.location.pathname)
                                ? undefined
                                : {marginTop: "1rem"}
                            }>
                                <div className="my-menu">
                                    <Menu
                                        items={[
                                            {
                                                label: t(getNotificationsLabel()),
                                                url: MENU.NOTIFICATIONS.URL,
                                                icon: alert,
                                                width: "1rem",
                                            },
                                            ...(showContactMenu ? [{
                                                label: t(MENU.CONTACT.LABEL),
                                                url: `${REACT_APP_BASE_URL}/${t("urls.vo")}`,
                                                icon: mail,
                                                width: "1.4rem",
                                            }] : []),
                                        ]}
                                        LinkNavigate={(props: any) => linkNavigate(props.to, props.children)}
                                    />
                                </div>

                                <CardsMenu LinkNavigate={linkNavigate} props={props}/>
                            </div>
                            <div className="component-wrapper">
                                <Component {...props} />
                            </div>
                            <FooterComp/>
                        </>
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/",
                                state: {from: props.location},
                            }}
                        />
                    )
                }
            />
        );
    }
);